import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'klasmaBelow';
const args = {};

export class KlasmaBelow extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
